import React from 'react';
import Container from './Container';
const Hero = () => {
  return (
    <section className="hero">
            <Container>


      <div className="hero-container">
        <div className="hero-content">
          <h1>A Stronghold of Privacy for People and Families.</h1>
          <p>
            Securely Store, Access, and Share Your Medical Records Anytime, Anywhere. 
            Take control of your personal data with our HIPAA-compliant, AWS cloud-based 
            document storage solution. Designed for individuals, families, and healthcare providers.
          </p>
          <button className="hero-btn">Get Started</button>
          
          <div className="hero-badges">
            {/* HSA FSA Badge */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', background: 'white', padding: '0.5rem 1rem', borderRadius: '0.5rem', border: '2px solid #1e3a8a' }}>
              <div style={{ fontWeight: 'bold', fontSize: '1.25rem', color: '#1e3a8a' }}>HSA</div>
              <div style={{ fontSize: '0.75rem', color: '#1e3a8a' }}>ELIGIBLE</div>
              <div style={{ fontWeight: 'bold', fontSize: '1.25rem', color: '#1e3a8a', marginTop: '0.25rem' }}>FSA</div>
            </div>

            {/* HIPAA Compliant Badge */}
            <div style={{ background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)', padding: '0.75rem 1.25rem', borderRadius: '50%', width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', boxShadow: '0 4px 10px rgba(0,0,0,0.2)' }}>
              <div style={{ fontWeight: 'bold', fontSize: '0.7rem', color: 'white', textAlign: 'center' }}>HIPAA</div>
              <div style={{ fontWeight: 'bold', fontSize: '0.85rem', color: 'white', textAlign: 'center' }}>COMPLIANT</div>
            </div>

            {/* BBB Accredited Badge */}
            <div style={{ background: '#1e3a8a', padding: '0.75rem 1.25rem', borderRadius: '0.375rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{ background: 'white', padding: '0.5rem', borderRadius: '0.25rem', fontWeight: 'bold', color: '#1e3a8a', fontSize: '1.25rem' }}>BBB</div>
              <div style={{ color: 'white', fontSize: '0.75rem', lineHeight: 1.2 }}>
                <div style={{ fontWeight: 'bold' }}>ACCREDITED</div>
                <div>BUSINESS</div>
              </div>
            </div>
          </div>
        </div>

        <div className="hero-image-wrapper">
          <img 
            src="https://images.unsplash.com/photo-1519681393784-d120267933ba?w=800&h=600&fit=crop" 
            alt="Person with flashlight against starry sky" 
            className="hero-image"
          />
        </div>
      </div>

                  </Container>
      {/* Privacy Footer */}
      <div className="privacy-footer">
        <div className="privacy-footer-container">
          <p>
            By use of ELDR website, <a href="#terms">data retrieval agreement with the Privacy and TermsConditions Act</a>, Inc. to view the specific content
          </p>
          <div className="privacy-links">
            <a href="#terms" className="privacy-link-btn">Terms of Service</a>
            <a href="#privacy" className="privacy-link-btn">Privacy Statement</a>
            <a href="#notice" className="privacy-link-btn">Notice of Privacy</a>
            <a href="#disclaimer" className="privacy-link-btn">Disclaimer</a>
          </div>
          <p>Copyright © ELDR 2025. All Rights Reserved</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
